var _polygon, _polygon2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 468.46 445.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-6",
    cx: 234.23,
    cy: 309.99,
    rx: 234.23,
    ry: 135.23,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-6",
    d: "M264.09,402.7h-8.87a3.13,3.13,0,0,1-3.13-3,170.17,170.17,0,0,0-2.6-25.75,3.13,3.13,0,0,1,4.65-3.27l92.92,53.65a3.14,3.14,0,0,1,0,5.43h0a3.13,3.13,0,0,0,1.47,5.85l57.92,1.76a3.13,3.13,0,0,0,3.21-3.42l-3-33.43a3.15,3.15,0,0,0-4.7-2.44l-5.21,3a3.14,3.14,0,0,1-3.14,0L306.9,351a3.14,3.14,0,0,1,1.75-5.85c13.37.74,28.19,1.16,44.65,1.26a3.14,3.14,0,0,1,3.12,3.13v1.29a3.14,3.14,0,0,0,4.58,2.79l42.67-22.17a3.14,3.14,0,0,0,0-5.57L361,303.75a3.14,3.14,0,0,0-4.58,2.78v1.23a3.14,3.14,0,0,1-3.16,3.14c-90.54-1-120.11-18.49-144-32.65-2.1-1.24-4.16-2.46-6.22-3.65l-73.62-42.51a263.81,263.81,0,0,0-46.86,21A193.16,193.16,0,0,0,55,272.18l80.77,46.63c2.06,1.19,4.17,2.38,6.32,3.59,24.62,13.84,52.36,29.44,55.14,77a3.14,3.14,0,0,1-3.13,3.33h-8.53a3.14,3.14,0,0,0-1.69,5.78l39.25,25.18a3.13,3.13,0,0,0,3.38,0l39.26-25.18A3.14,3.14,0,0,0,264.09,402.7Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.87,108l7.94,4.58a9.57,9.57,0,0,1-.07-1v-2.3c0-4.09,2.87-5.75,6.41-3.71a12.35,12.35,0,0,1,3.82,3.68c.58-5.14,4.62-7.06,9.52-4.23,5.3,3.06,9.59,10.5,9.59,16.62V125a9,9,0,0,1-.81,4l6.59,3.8a7.9,7.9,0,0,1,3.56,6.16c0,2.27-1.6,3.19-3.56,2.06l-43-24.82a7.86,7.86,0,0,1-3.55-6.16C417.32,107.79,418.91,106.87,420.87,108Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.61,73.68l-4.38-3.37V60.67c0-7.64-6.09-16.51-12.71-20.33h0c-6.62-3.82-12-.73-12,6.92v1.4A17.19,17.19,0,0,0,393,43.09h0c-4.77-2.75-8.63-.52-8.63,5v.64l-6.1-3.53c-3.13-1.81-5.68-.34-5.68,3.28a12.58,12.58,0,0,0,5.68,9.84l49.36,28.49c3.13,1.81,5.68.35,5.68-3.28A12.56,12.56,0,0,0,427.61,73.68Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Way--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.87,426.12v6.29L354,430.86v-6.29l1.61-.93-113-65.26c3.32,11.63,5,25.66,5,42.45H258.9v6.3L224.84,429l-34.06-21.84v-6.3H202c-2.45-56-37.79-71.23-63.87-86.29C131,310.44,92.51,288.22,59,268.89v-6.31a197.32,197.32,0,0,1,23.54-15.85,259.58,259.58,0,0,1,41.28-19l76.87,44.39c27,15.61,54.39,37,160.36,37v-6.56l37.84,19.67v6.29l-37.84,19.66v-6.55c-29.08,0-53.39-.95-73.53-2.86l107.59,62.12,7.05-4.08Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.87,426.12v6.29L354,430.86v-6.29l1.61-.93-113-65.26c3.32,11.63,5,25.66,5,42.45H258.9v6.3L224.84,429l-34.06-21.84v-6.3H202c-2.45-56-37.79-71.23-63.87-86.29L59,268.89v-6.31a197.32,197.32,0,0,1,23.54-15.85,259.58,259.58,0,0,1,41.28-19l.26.15,76.61,44.24c27,15.61,54.39,37,160.36,37v-6.56l37.84,19.67v6.29l-37.84,19.66v-6.55c-29.08,0-53.39-.95-73.53-2.86l107.59,62.12,7.05-4.08Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.14,400.84H202c-2.46-56-37.8-71.23-63.88-86.29L59,268.9v-6.31l79.09,45.67C165.15,323.86,202.14,339.66,202.14,400.84Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.08,335.3v6.28c-29.08,0-53.39-.95-73.53-2.86L274,330.93c11.25,1.46,24,2.55,38.5,3.28S343.12,335.3,361.08,335.3Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,424.57l7.06-4.07L240,350.58c5.07,13,7.57,29.52,7.57,50.25H258.9l-34.06,21.85-34.06-21.85h11.35c0-61.17-37-77-64-92.58L59.07,262.61l0,0a197.32,197.32,0,0,1,23.54-15.85,259.58,259.58,0,0,1,41.28-19l.26.15,76.61,44.24c27,15.61,54.39,37,160.36,37v-6.56l37.84,19.67-37.84,19.66v-6.55c-18,0-34.09-.36-48.55-1.09s-27.25-1.81-38.49-3.28l121.1,69.92,7.05-4.08,2.68,29.36Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.08,420.5l-5.45,3.15-113-65.26c-.84-3-1.71-5.51-2.61-7.8Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.87 383.99 210.87 390.28 176.81 368.43 176.81 362.14 210.87 383.99",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Signal--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.64,87.44a1.8,1.8,0,0,0-1-1.4,5.55,5.55,0,0,0-5,0,1.77,1.77,0,0,0-1,1.4h0V343.16c0,1.1,1.58,2,3.53,2s3.53-.9,3.53-2h0V87.44Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.14,
    cy: 48.74,
    rx: 3.53,
    ry: 2,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.04 94.04 323.11 82.04 277.07 55.48 273.59 57.49 273.59 73.48 319.63 100.04 323.18 98.08 330.04 94.04",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.59 57.49 319.63 84.05 326.55 96.05 319.63 100.04 273.59 73.48 273.59 57.49",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "273.59 57.49 319.63 84.05 326.57 96.08 319.63 100.04 273.59 73.48 273.59 57.49"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "323.11 82.04 319.63 84.05 273.59 57.49 277.07 55.48 323.11 82.04",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.63 84.05 323.11 82.04 330.04 94.04 326.57 96.08 319.63 84.05",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.04 150.06 323.11 138.06 277.07 111.5 273.59 113.51 273.59 129.5 319.63 156.06 323.18 154.1 330.04 150.06",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.59 113.51 319.63 140.07 326.55 152.06 319.63 156.06 273.59 129.5 273.59 113.51",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "273.59 113.51 319.63 140.07 326.57 152.1 319.63 156.06 273.59 129.5 273.59 113.51"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "323.11 138.06 319.63 140.07 273.59 113.51 277.07 111.5 323.11 138.06",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.63 140.07 323.11 138.06 330.04 150.06 326.57 152.1 319.63 140.07",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.27 102.71 257.23 76.11 250.3 80.11 257.23 92.1 303.27 118.7 303.27 102.71",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.23 76.11 260.61 74.07 306.72 100.72 303.27 102.71 257.23 76.11",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "257.23 76.11 260.61 74.07 306.72 100.72 303.27 102.71 257.23 76.11",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "306.72 116.71 303.27 118.7 303.27 102.71 306.72 100.72 306.72 116.71",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.72 116.71 303.27 118.7 303.27 102.71 306.72 100.72 306.72 116.71",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-6",
    cx: 120.17,
    cy: 232.09,
    rx: 39.42,
    ry: 22.76,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.32,266.09a3.25,3.25,0,0,1-.26,2.62,11.24,11.24,0,0,1-8.54,2.63,20.73,20.73,0,0,1-9.27-3.24,12.05,12.05,0,0,0-7.13-1.76c-2.59,0-4.51-.5-4.73-1.17-.39-1.19-.42-1.94.15-1.93Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.43,255a8.22,8.22,0,0,0,8.93.63l.54-16.95H136.73Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,262.71a55.8,55.8,0,0,1-11.51-5.53c-.76-.54-1.35-1-1.85-1.42-1.13-1.14-1.82-3.61-2.31-3.89s-1.31.62-1.7.83a7.49,7.49,0,0,1-2.63.87c-2.73.35-2.84-.2-2.92.69a6.66,6.66,0,0,0,0,1c-1.45-.19-2.6-.61-2.69-1.16l-.24-1.74c-1.44-.08-1.44,2.5-1.8,5.41-.3,2.35-.8,4.07-.09,5.77,2.25,1.82,6.07,1.21,8.27,1.49,3.11.4,4.64,2.63,9,4,7,2.14,11.29-.79,12.54-2.05C166.9,265.37,166.43,263.62,164,262.71Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.12,281.13c-.12,1.06-.28,4-5.67,4.76s-8.78-1.08-10.21-3.68-1.09-4.71-1.31-7.11-2.2-3.69-2.77-4.93c-.83-1.82.41-4.65.41-4.65Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,261.35c.65,4.92,10.19,4.56,9.42.63L117,250.05l-10.79.3Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.74,278.68a32.82,32.82,0,0,0-2.47-3,26.68,26.68,0,0,1-5.55-14.32c0-.29-.06-.85-.34-1s-.59.07-.89.2h0v0a5.6,5.6,0,0,1-1.68.43,31.66,31.66,0,0,1-4.49-.19c-.37.05-.49,1.19-.47,2.44-.67-.44-.89-1.29-1.5-1.79-.33-.27-.48-.28-.47-.72s0-.54,0-.83c-.49-.15-.91,1.73-1.31,3.16-.48,1.66-1.06,3.53-.42,5.22a14.17,14.17,0,0,0,1.51,2.61,10.75,10.75,0,0,1,1.94,4.78c.07.75,0,1.52.12,2.27a6.66,6.66,0,0,0,4.68,5.5c3.28,1,8.22.89,11.12-1.4C124.55,281.26,124.21,279.57,123.74,278.68Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1,150.72c-2.14,19.68-2.49,54.67-2.49,54.67s-3.24,9.16-3.23,16c0,14.34.37,34,.37,34a17.5,17.5,0,0,0,10.67.42s5.46-32,7.89-43.58c2.13-10.07,5.55-33.05,5.55-33.05l4.71,28.15a73.37,73.37,0,0,0-1.34,15.83c.22,5.42,4.24,26.24,4.24,26.24,1.76,1.66,8.17.27,10.43-1.17,0,0,1.58-35.09,2.06-40.78.63-7.5,1.78-61.24,1.78-61.24Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.86,179.16l2.63-12.1a28.63,28.63,0,0,0,10.06-4.7s-1.54,3.86-8,6.82l-2.68,11.33,2.3,24.88Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.33,97c-.57-1.72-3.71-.24-7,1.35-3,1.46-8.86,4.26-9.28,3.66s-.08-3.12-.81-4.76-2.67-2.15-2.66-.69c0,.84-.51,3.63-.68,4.91s-.49,3-1.75,3.76-25.82,4.55-25.82,4.55-19.1-11.33-23-13.91-7-5.07-12.8-4.78c-7.6,2.73-5,9.73-1.77,14.21,1.79,2.46,2.45,2.4,9.08,5.2,8,3.39,20.64,10.63,27.45,11.65,7.65-.78,27.81-6.42,29.79-6.74,2.36-.39,3.86.07,5.77-.25,2.29-.4,4.25-.63,6.32-1.86a2.37,2.37,0,0,0,1.28-1.53c.06-.34,0-.69,0-1a13,13,0,0,0,.44-1.68c0-.75-.83-1.46-.79-2.21,0-.33.5-1.21.41-1.53a6.08,6.08,0,0,0-.79-1.34c-.15-.28-.6-.76-.3-1.06s1.39-.78,3.59-2.3S226.72,98.14,226.33,97Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22,90.6c3.4,0,5.51-.54,14.94,5.41s21.26,13.47,21.26,13.47l12.4-1.72s-1.62,4.61,1.62,11.28c0,0-11.53,3.12-14.23,3.6s-2.38.29-6.57-1.3-25.49-11.54-25.49-11.54Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.9,103.84c-1.82,1.19-4.13,2-4.25,3.25a1.72,1.72,0,0,0,1.92,1.77,1.71,1.71,0,0,0-.54,1.61,1.56,1.56,0,0,0,1.18,1.14,1.63,1.63,0,0,0,.74,2.26c-.69,0-2-.39-1.58-1.68,0,0-1.67-1-1-2.45,0,0-.69,1.69-3.43,2.1a6.06,6.06,0,0,0,2.83-2.84,2.46,2.46,0,0,1-.77-2.42C211.43,105.17,215.9,103.84,215.9,103.84Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.1,91c-5.5.83-11.79,1.27-15.64,1.8-4.21.57-5.72,4-5.72,11.22,0,10.6,5.43,28.28,5.43,28.28l-1.07,18.46c4.93,5.28,28.15,7.19,40.75-.54,0,0,.33-35.95,0-42-.6-10.66-6.77-17.49-10.7-17.79C141.15,90.37,137.55,89.52,128.1,91Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.78,58s-3,.42-4.12,2.69c-1,2-.62,6.74.67,11.94a47.55,47.55,0,0,0,3.24,9.77,3.94,3.94,0,0,0,2.3,1.84l-.15-6.17-.23-4.29s2.76-3.77,3.07-6.86c.39-4-.45-5.6-.45-5.6Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.07,58.76l-4.25-1.94A2.48,2.48,0,0,1,121,55.5,2.4,2.4,0,0,1,122.07,58.76Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.64,64a11.52,11.52,0,1,0,11.48-11.55A11.52,11.52,0,0,0,127.64,64Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.66,73.1c-1,.9-1.88-1.43-2.76-2.34s-3.71-2.14-5.12.85,1.31,7.18,3.43,8.17c3.11,1.44,4.51-1.7,4.51-1.7l.33,13c3.28,5.9,9.73,5.78,10.75,8.48.61-2.4,4-5.39,1.78-8l0-4.22a24.87,24.87,0,0,0,5.19.25c2.83-.45,4.31-2.59,5.16-5.65,1.36-4.93,1.91-13.21,0-22.78-3.17-2.45-14.17-2-20.82,2.17C127.6,69.82,125.69,72.2,124.66,73.1Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,52.38a.52.52,0,0,0-.42-.31.62.62,0,0,0-.38.16,18.26,18.26,0,0,1-2.52,1.7,9.25,9.25,0,0,0,0-3.44c-.13-.7-.32-2.31-1.19-2.48-.51-.11-1,.32-1.34.68-3.46,3.24-8,1.74-12.15,1.87-3.49.12-7.7,1.53-9.27,4.93-.72,1.55-.85,3.18.58,4.25a9.76,9.76,0,0,0,4.25,1.59c7,1.21,16.9,4.07,22-2.41a5.13,5.13,0,0,0,1.07-3.4,7.05,7.05,0,0,0-.69-3.1A.05.05,0,0,1,149.51,52.38Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56,87.34s-6.33-1.26-8.54-2.42a7.38,7.38,0,0,1-3.07-3,9.89,9.89,0,0,0,1.75,3.56c1.62,2.06,9.86,3.56,9.86,3.56Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.07,71.18a1.28,1.28,0,0,1-1.26,1.32,1.32,1.32,0,1,1,1.26-1.32Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.59,66.46l-2.83,1.26a1.62,1.62,0,0,1,.81-2.09A1.51,1.51,0,0,1,135.59,66.46Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.54,79.63l4,1.51a2.12,2.12,0,0,1-2.74,1.34A2.26,2.26,0,0,1,136.54,79.63Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.84,82.48a2.06,2.06,0,0,0,1.12.09,2,2,0,0,0-2-1.88,1.67,1.67,0,0,0-.55.09A2.2,2.2,0,0,0,137.84,82.48Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.63,67.27l-2.93-1.08a1.49,1.49,0,0,1,2-1A1.64,1.64,0,0,1,147.63,67.27Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.53,70.76a1.27,1.27,0,1,1-1.27-1.32A1.29,1.29,0,0,1,146.53,70.76Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.26,70.45l.42,7.23,4-1.37-4-5.94A1,1,0,0,0,140.26,70.45Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,87.42c-.81.06-1.16.18-1.82,1.49-.74,1.49-1.38,2.85-1.38,2.85a9,9,0,0,0,2.71,5.76,24.36,24.36,0,0,0,5.32,4.12A20,20,0,0,1,132.16,99a2.29,2.29,0,0,1,3.21-.11,9.29,9.29,0,0,0-1.44-2.25c-.49-.52-2.48-1.12-5.2-2.83A9.91,9.91,0,0,1,125,89Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.07,98.81a5.83,5.83,0,0,1,1.16-3c.7-1.36.32-2.43.33-3.58s0-3.72,0-3.72a2.26,2.26,0,0,1,2.18,1.72c.58,1.43,1.79,3.2,1.79,6.43,0,2.9-.27,3.44-.27,3.44A17.84,17.84,0,0,0,138.5,98,1.63,1.63,0,0,0,136.07,98.81Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.46,92.76c-5.61,0-9.44,3.75-13.2,10-2.92,4.83-13.82,23.3-16,28.51-2,4.74-2.12,6.7,1.38,10,2.79,2.68,19.54,17,22.54,19.77a12.31,12.31,0,0,0,8.12,3.64c4.57.28,6.75-1.4,7.53-2.41,4.67-6.06-4.24-7.18-7.46-9.07a18.73,18.73,0,0,1-4.23-3.42l.15-2.47s-3.52.09-4.62-.76-10.07-11.92-10.07-11.92l14.8-21.27C114.42,109.85,116.39,97.7,112.46,92.76Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4,92.76c-4.48-.68-8.74.41-13.23,7.51S84.3,127.61,83,130.78s-3.18,6.5.54,9.94S91,147.38,91,147.38c.94-2.78,5.09-7.6,8.51-9.15l-2.16-3.33s13-19.33,15.38-22.72S117,101,113.4,92.76Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.42,287.92,74.88,283s2.07-18.1.69-32.11c-1.94-19.7-14.66-43.4-29.83-37.83s6.95,25.62,11.88,42.33S66.42,287.92,66.42,287.92Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,287.92,74.88,283s2.07-18.1.69-32.11c-1.94-19.7-14.66-43.4-29.83-37.83s6.95,25.62,11.88,42.33S66.42,287.92,66.42,287.92Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.87,285.87h0a.51.51,0,0,1-.49-.53c1.48-43.77-20.31-65.78-20.53-66a.51.51,0,0,1,.72-.73c.23.22,22.33,22.56,20.83,66.77A.52.52,0,0,1,70.87,285.87Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.11,291l6-3.48s1-12.42-5.06-27.5C56.76,246.85,43.6,236,37,238.24s-6.45,7-3.23,11.91S56.61,266.8,61.11,291Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.28,289.65h0a.51.51,0,0,1-.51-.52c.12-27.67-25.86-46.37-26.13-46.56a.51.51,0,1,1,.6-.83c.26.19,26.68,19.2,26.55,47.4A.51.51,0,0,1,64.28,289.65Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.1,283.62l-7.29-4.22s-4.34-18-2.61-34.26c2.43-22.82,17.45-31.4,23.16-29.43s7.37,8.6-2.08,22.19C434.7,245.92,427.85,262.62,429.1,283.62Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M429.1,283.62l-7.29-4.22s-4.34-18-2.61-34.26c2.43-22.82,17.45-31.4,23.16-29.43s7.37,8.6-2.08,22.19C434.7,245.92,427.85,262.62,429.1,283.62Z",
    transform: "translate(-13.97 -38.7)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M426.08,274.76h.07a.51.51,0,0,0,.41-.59c-4-21.05,3.35-44.69,12.45-54.54a.5.5,0,0,0-.74-.68C429,229,421.51,253,425.56,274.35A.51.51,0,0,0,426.08,274.76Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.21,294.65c1.15.59,4.21-2,5.07-2.67a10.9,10.9,0,0,0,3.35-4.26,10,10,0,0,0,.58-6.06,23.29,23.29,0,0,0-.92-3.16l-1.05-3.06a8,8,0,0,1-.61-3.11c.16-2.13,2-3.72,3.62-5.09,1.82-1.51,3.7-3.48,3.56-6a8.93,8.93,0,0,0-2.52-5.23c-1.3-1.49-2.82-2.79-4-4.36a6.26,6.26,0,0,1-1.49-3.91,6.43,6.43,0,0,1,.74-2.52,34.86,34.86,0,0,0,2.46-5.12c.54-1.82.33-4-1.13-5.24a5.82,5.82,0,0,0-4.45-.88,10.18,10.18,0,0,0-4,1.65c-3.94,2.46-6,7.38-10.23,9.34a43,43,0,0,1-5.15,1.53,6.46,6.46,0,0,0-4.15,3.16c-1.42,3.24,1.71,7,.77,10.39-.83,3-3.66,4.29-5.14,7.05a6.28,6.28,0,0,0-.56,3.92,18.69,18.69,0,0,0,2,6.47,59.06,59.06,0,0,0,3.9,6S448,294.56,448.21,294.65Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.05,288.83h0a.5.5,0,0,0,.46-.55c-1.84-20,6.49-42.64,13-49.42a.51.51,0,0,0-.73-.7c-6.68,6.92-15.19,29.91-13.31,50.21A.51.51,0,0,0,437.05,288.83Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,264.15l.15,0A68,68,0,0,1,453.62,261a.51.51,0,0,0,.46-.55.49.49,0,0,0-.55-.46,69.41,69.41,0,0,0-14.69,3.14.5.5,0,0,0,.19,1Z",
    transform: "translate(-13.97 -38.7)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.ff6e788e7e1c564b7bec8b3a03bafdf9.svg";
export { ForwardRef as ReactComponent };